import { getAttachment } from '../store/services/reportServiceClient'

const getAttachmentUrl = async (runId, attachmentType, ref) => {
  try {
    const response = await getAttachment(runId, attachmentType, ref)
    return response.data.AttachmentUrl
  } catch (e) {
    throw new Error(`Url for attachment ${ref} could not be obtained : ${e.response?.status}`)
  }
}

export {
  getAttachmentUrl
}
